import { motion } from 'framer-motion';
import { StepConfigurationsContainer } from './step-configurations-container';

interface StepConfigurationsProps {
  proposalId?: string;
  onValidationChange?: (isValid: boolean) => void;
}

export function StepConfigurations({ proposalId, onValidationChange }: StepConfigurationsProps) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <StepConfigurationsContainer
        proposalId={proposalId}
        onValidationChange={onValidationChange}
      />
    </motion.div>
  );
}
